const es = {
  "nav.services": "Servicios",
  "nav.story": "Quiénes somos",
  "nav.process": "Cómo trabajamos",
  "nav.faq": "Preguntas",
  "nav.contact": "Contacto",
  "nav.call": "+598 93 855 338",

  "seo.title": "Facundo Yoldi | Enfermero a domicilio en Maldonado",
  "seo.desc": "Enfermería a domicilio en Maldonado y Punta del Este, en un radio de 20 km: control, curaciones, inyecciones y post-operatorio. WhatsApp +598 93 855 338.",

  "beat1.stamp": "01 — Enfermería a domicilio",
  "beat1.h1": "Cuidar en casa,<br>con <em class=\"accent\">manos</em> expertas.",
  "beat1.sub": "Enfermero titulado. Atención domiciliaria en Maldonado, Punta del Este y 20 km a la redonda.",
  "beat1.local": "Enfermería a domicilio en Maldonado y Punta del Este",
  "beat1.cta": "Solicitar una visita",

  "beat2.stamp": "02 — Servicios a domicilio",
  "beat2.h2a": "Control, curas",
  "beat2.h2b": "y <em class=\"accent\">compañía</em>.",
  "beat2.sub": "Tu medicación al día, tu recuperación en casa, tu familia tranquila.",
  "beat2.chip1": "Tensión y glucemia",
  "beat2.chip2": "Curaciones e inyectables",
  "beat2.chip3": "Post-operatorio",

  "beat3.quote": "La atención no se improvisa.",
  "beat3.stamp": "Facundo Yoldi · Enfermero",

  "beat4.stamp": "04 — Contacto y reservas",
  "beat4.h2": "Coordinamos hoy<br>tu primera <em class=\"accent\">visita</em>.",
  "beat4.sub": "WhatsApp +598 93 855 338 — respondemos el mismo día.",
  "beat4.cta": "Pedir turno",

  "manifesto": "La mejor recuperación no ocurre en un pasillo de hospital, sino en casa, con alguien que <em class=\"accent\">sabe mirar</em> a tiempo.",

  "story.stamp": "02 — Quiénes somos",
  "story.h2": "Un enfermero,<br>no una <em class=\"accent\">agencia</em>.",
  "story.sub": "Facundo Yoldi es enfermero titulado y trabaja siempre en primera persona. La misma persona que entra por tu puerta es la que sigue tu historia clínica: conoce tu medicación, tu casa y a tu familia, y no hay que explicarle nada dos veces.",
  "story.point1": "Seguimiento continuo con un único profesional.",
  "story.point2": "Informe escrito a la familia después de cada visita.",
  "story.point3": "Derivación al médico de referencia cuando corresponde.",
  "story.imageAlt": "Enfermero con guantes azules en el umbral de una casa",

  "services.stamp": "03 — Servicios",
  "services.h2": "Todo lo que pasa<br>en una <em class=\"accent\">casa</em>.",
  "services.sub": "Visitas de 45 a 60 minutos, con los insumos necesarios.",
  "services.s1t": "Control y monitoreo",
  "services.s1d": "Tensión, glucemia, saturación. Parámetros registrados en cada visita.",
  "services.s2t": "Curaciones",
  "services.s2d": "Heridas, úlceras y quemaduras con material estéril.",
  "services.s3t": "Medicación e inyectables",
  "services.s3d": "Administración endovenosa, intramuscular o subcutánea según indicación.",
  "services.s4t": "Post-operatorio",
  "services.s4d": "Cambio de vendajes, drenajes y control del dolor.",
  "services.imageAlt": "Enfermero tomando la presión a una mujer mayor en el living de su casa",

  "numbers.title": "En números",
  "numbers.n1": "Años de experiencia",
  "numbers.n1c": "En hospital y a domicilio.",
  "numbers.n2": "Visitas realizadas",
  "numbers.n2c": "Desde 2019, en Maldonado y Punta del Este, en un radio de 20 km.",
  "numbers.n3": "Respuesta",
  "numbers.n3c": "El mismo día, por WhatsApp.",
  "numbers.n4": "Calificación",
  "numbers.n4c": "Promedio de las familias atendidas.",

  "process.stamp": "05 — Cómo trabajamos",
  "process.h2": "De un mensaje<br>a una <em class=\"accent\">visita</em>.",
  "process.sub": "Sin trámites largos: tres pasos y estamos en tu casa.",
  "process.p1": "Escribís por WhatsApp",
  "process.p1d": "Contanos el caso, la dirección y el horario que le sirve a la familia.",
  "process.p2": "Coordinamos una evaluación",
  "process.p2d": "Primera visita para conocer la situación y armar el plan.",
  "process.p3": "Arranca el seguimiento",
  "process.p3d": "Visitas programadas e informe después de cada una.",
  "process.imageAlt": "Enfermero junto a una paciente mirando por la ventana al atardecer",

  "faq.stamp": "06 — Preguntas",
  "faq.h2": "Lo que más<br>nos <em class=\"accent\">preguntan</em>.",
  "faq.q1": "¿En qué zonas trabajan?",
  "faq.a1": "Maldonado, Punta del Este y 20 km a la redonda, con visitas de lunes a sábado. Fuera de esa área consultanos por WhatsApp y vemos si podemos cubrirlo.",
  "faq.q2": "¿Cuánto cuesta una visita?",
  "faq.a2": "Depende del procedimiento y de la frecuencia. Te pasamos el valor exacto por WhatsApp antes de reservar, sin sorpresas.",
  "faq.q3": "¿Atienden urgencias?",
  "faq.a3": "No somos un servicio de emergencia. Para emergencias llamá al 911. Atendemos consultas y visitas programadas el mismo día cuando hay disponibilidad.",
  "faq.q4": "¿Qué precisan para la primera visita?",
  "faq.a4": "La receta o indicación médica, los estudios previos y los datos del médico de referencia. Si no tenés receta, coordinamos igual una evaluación.",
  "faq.q5": "¿Trabajan con obras sociales?",
  "faq.a5": "Trabajamos de forma particular. Igual emitimos la documentación para que puedas presentarla en tu cobertura si la acepta.",

  "reviews.stamp": "07 — Reseñas",
  "reviews.nav": "Reseñas",
  "reviews.h2": "Lo dicen<br>las <em class=\"accent\">familias</em>.",
  "reviews.sub": "Reseñas dejadas en Google por pacientes y familias de Maldonado y Punta del Este.",
  "reviews.score": "5,0",
  "reviews.scoreCap": "Promedio en Google",
  "reviews.count": "10 reseñas · todas de 5 estrellas",
  "reviews.starsLabel": "5 de 5 estrellas",
  "reviews.date": "Hace 3 meses",
  "reviews.r1": "Excelente profesional, muy recomendable por todo su trabajo y su actitud.",
  "reviews.r2": "¡Excelente profesional! ¡Excelente para dar inyecciones! Muy recomendable.",
  "reviews.r3": "Excelente servicio, muy confiable y responsable. Realmente recomendable, una muy buena experiencia.",
  "reviews.r4": "¡Excelente servicio y un acompañamiento increíble! Muy recomendable.",
  "reviews.r5": "¡Excelente profesional! ¡Atento y dedicado! Muy recomendable.",
  "reviews.r6": "Responsable, comprometido, un profesional de confianza y dedicado a la salud. 100% recomendable.",
  "reviews.r7": "Excelente profesional, muy cálido y amable.",
  "reviews.r8": "Excelente servicio.",

  "contact.stamp": "08 — Contacto",
  "contact.h2": "Escribinos y<br>nos <em class=\"accent\">organizamos</em>.",
  "contact.sub": "Contanos qué necesitás. Respondemos en el mismo día, de lunes a sábado.",
  "contact.langNote": "Hablamos español e inglés",
  "contact.talkLang": "¿En qué idioma querés que te hablemos?",
  "contact.name": "Nombre y apellido",
  "contact.namePh": "Tu nombre",
  "contact.phone": "Teléfono / WhatsApp",
  "contact.phonePh": "+598 93 855 338",
  "contact.email": "Correo electrónico",
  "contact.emailPh": "nombre@correo.com",
  "contact.zone": "Barrio o localidad",
  "contact.zonePh": "Ej. Punta del Este, Maldonado",
  "contact.service": "Tipo de servicio",
  "contact.servicePh": "Elegí una opción",
  "contact.service1": "Control y monitoreo",
  "contact.service2": "Curaciones",
  "contact.service3": "Medicación e inyectables",
  "contact.service4": "Post-operatorio",
  "contact.service5": "Otra consulta",
  "contact.message": "Contanos tu caso",
  "contact.messagePh": "Breve descripción de la situación y el horario que les sirve (máx. 500 caracteres)",
  "contact.submit": "Enviar consulta",
  "contact.submitting": "Enviando…",
  "contact.ok": "Recibimos tu mensaje. Te escribimos hoy mismo por WhatsApp.",
  "contact.err": "No pudimos enviar el formulario. Probá de nuevo o escribinos por WhatsApp al +598 93 855 338.",
  "contact.fallbackTitle": "No lo escribas de nuevo: mandalo por WhatsApp",
  "contact.fallbackText": "El formulario no salió, pero no se perdió nada. Tocá abajo y el chat se abre con tu nombre, el servicio y tu mensaje ya escritos.",
  "contact.fallbackBtn": "Enviarlo por WhatsApp",
  "contact.waLeadEs": "Hola Facundo, te escribo desde la web porque no pude enviar el formulario.",
  "contact.waLeadEn": "Hi Facundo, I'm writing from the website because the form wouldn't send.",
  "contact.direct": "También podés escribir directo",
  "contact.waBtn": "Abrir WhatsApp",
  "contact.waTextEs": "Hola Facundo, te escribo desde la web. Quería consultar por una visita de enfermería a domicilio.",
  "contact.waTextEn": "Hi Facundo, I'm writing from the website. I'd like to ask about a home nursing visit.",
  "contact.waHintEs": "El chat se abre con el mensaje ya escrito en español.",
  "contact.waHintEn": "El chat se abre con el mensaje ya escrito en inglés.",

  "chat.hint": "Respondo en español o inglés — Facundo",
  "chat.hintClose": "Ocultar este aviso",

  "footer.tag": "Enfermería a domicilio",
  "footer.desc": "Atención de enfermería profesional en tu casa, con seguimiento y trato humano.",
  "footer.nav": "Navegación",
  "footer.contact": "Contacto",
  "footer.hours": "Lunes a sábado · 8:00 a 20:00",
  "footer.legal": "© 2026 Facundo Yoldi · Enfermería a domicilio. Maldonado y Punta del Este, Uruguay.",
  "footer.backTop": "Volver arriba",
};

export default es;